
import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="pursuitsLinkman";

export function deleteLinkman(pursuitsId,linkmanId) {
  return axios({
    url: `/ws/${moduleName}/${pursuitsId}/${linkmanId}`,
    method: 'delete'
  })
}

export function selectByPursuitsId(pursuitsId){
  return axios({
    url: `/ws/${moduleName}/selectByPursuitsId/${pursuitsId}`,
    method: 'get',
  })
}


export function updateLinkmanDOS(pursuitsId, linkmanDOS){
  return axios({
    url: `/ws/${moduleName}/updateLinkmanDOS/${pursuitsId}`,
    method: 'put',
    data: linkmanDOS,
  })
}


export default {
  deleteLinkman,
  selectByPursuitsId,
  updateLinkmanDOS
}